import { imageEncodeTransformer, youtubeEncodeTransformer } from './tagTransformers';
import { transformTags } from './transformTags';

export const encodeChangeTags = (html: string, { assetBasePath }: { assetBasePath: string }): string => {
	const { transformer: imageTransformer } = imageEncodeTransformer({ assetBasePath });
	const { transformer: youtubeTransformer } = youtubeEncodeTransformer();

	return transformTags({ html, transformers: [imageTransformer, youtubeTransformer] });
};
